import { useMemo } from "react";
import { UserRegistrationDao } from "./UserRegistrationDao";

export const useUserRegistrationDao = (token: string | undefined) => {
  return useMemo(() => {
    return token ? new UserRegistrationDao(token) : undefined;
  }, [token]);
};
